@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.root {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  @include typography-v2-body-base;
}

.tickerButton {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 6px;
  border: 0;
  background: transparent;
  color: inherit;
  @include border-radius-r05;
  font: inherit;
  cursor: pointer;
  min-width: 0;
}

.tickerButton:hover {
  background: var(--surface-hover);
}

.logoSlot {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.ticker {
  @include typography-v2-body-base;
  text-transform: uppercase;
  color: var(--text-default);
  overflow: hidden;
  text-overflow: ellipsis;
}

.separatorDot {
  display: inline-block;
  width: 4px;
  height: 4px;
  @include border-radius-full;
  margin: 0 6px;
  background: var(--icon-default);
}

.indicatorButton {
  @include typography-v2-body-base;
  @include border-radius-r05;
  padding: 2px 6px;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.indicatorButton:hover {
  background: var(--surface-hover);
}
